module.exports = __webpack_public_path__ + "img/livecamera_tokyo.7e2b7bdb.png";